export const PlayyardSnowDrifts = () => {
  /* Render */
  const render = () => (
    <svg
      className="pointer-events-none absolute inset-x-0 bottom-0 z-[35] h-[6%] w-full"
      viewBox="0 0 1000 60"
      preserveAspectRatio="none"
    >
      <path
        d="M0 27Q96 0 183 26T381 33T603 22T804 31T1000 18V60H0Z"
        fill="var(--yard-groundTop)"
      />
      <path
        d="M0 43Q127 23 249 45T526 40T785 46T1000 34"
        fill="none"
        stroke="var(--yard-groundBottom)"
        strokeWidth="2"
        opacity="0.5"
      />
    </svg>
  );

  return render();
};
